// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-request-chips-container {
  line-height: 1.5;
  display: flex;
  padding: 10px 0 5px 0;
  align-items: center;
}
.search-request-chips-container .info-container {
  margin: 0 0 0 10px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.search-request-chips-container .info-container .text-container {
  font-size: 15px;
  font-weight: 600;
  color: #92949C;
  margin-right: 5px;
}
.search-request-chips-container .info-container ion-chip {
  padding: 0 7.5px 0 7.5px;
  font-size: 12px;
  font-weight: 600;
  min-height: 30px;
  border-radius: 10px;
}
.search-request-chips-container .info-container ion-chip ion-icon {
  margin-right: 3.5px;
  font-size: 18px;
}

.icon-container {
  display: flex;
  align-items: center;
}

.series-search-request-chips-container {
  display: flex;
  align-items: center;
  padding: 10px 10px 5px 10px;
}
.series-search-request-chips-container .info-container {
  font-size: 13px;
  padding: 0 5px 0 0;
  font-weight: 600;
  pointer-events: none;
  display: flex;
  align-items: center;
  width: 100%;
}
.series-search-request-chips-container .info-container ion-icon {
  margin-right: 5px;
  font-size: 21px;
}

ion-popover.datetime-popover::part(content) {
  width: unset;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/active-search-request-preview/active-search-request-preview.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AACJ;AAAG;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAEJ;AAAI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAEN;AAAI;EACE,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAEN;AAAM;EACE,mBAAA;EACA,eAAA;AAER;;AAKE;EACE,aAAA;EACA,mBAAA;AAFJ;;AAIE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AADJ;AAEI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAAN;AACM;EACE,iBAAA;EACA,eAAA;AACR;;AAMA;EACE,YAAA;AAHF","sourcesContent":[".search-request-chips-container {\n    line-height: 1.5;\n    display: flex;\n    padding: 10px 0 5px 0;\n    align-items: center;\n   .info-container {\n    margin: 0 0 0 10px;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    \n    .text-container {\n      font-size: 15px;\n      font-weight: 600;\n      color: #92949C;\n      margin-right: 5px;\n    }\n    ion-chip {\n      padding: 0 7.5px 0 7.5px;\n      font-size: 12px;\n      font-weight: 600;\n      min-height: 30px;\n      border-radius: 10px;\n  \n      ion-icon {\n        margin-right: 3.5px;\n        font-size: 18px;\n      }\n    }\n   }\n  }\n  \n\n  .icon-container { \n    display: flex;\n    align-items: center;\n  }\n  .series-search-request-chips-container {\n    display: flex;\n    align-items: center;\n    padding: 10px 10px 5px 10px;\n    .info-container {\n      font-size: 13px;\n      padding: 0 5px 0 0;\n      font-weight: 600;\n      pointer-events: none;\n      display: flex;\n      align-items: center;\n      width: 100%;\n      ion-icon {\n        margin-right: 5px;\n        font-size: 21px;\n      }\n    }\n  }\n\n\n\nion-popover.datetime-popover::part(content) {\n  width: unset;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
